export default __webpack_public_path__ + "static/media/shrapnel.b0acfc9b.png";